
export default {
  name: 'BrandCarousel',
  props: {
    loading: {
      type: Boolean,
    },
    popularCollections: {
      type: Array,
      default() { return []; },
    },
    popularCollectionsAll: {
      type: Number,
      default: 0,
    },
  },
};
